import { faFilePen, faPlus, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { AppBar, Autocomplete, Box, Button, Chip, Dialog, Grid, TextField, Toolbar, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useStyles } from '../../hooks/useStyles';
import { api } from '../../api';
import { SimpleAlertProps } from '../../components/SimpleAlert';
import { UserGroup } from '../../api/user-group';
import { useAuth } from '../../units/auth/AuthProvider';
import { useGlobal } from '../../units/global/GlobalProvider';
import car, { Car } from '../../api/car';
import { regLicensePlateNumber } from '../../data/LicensePlateNumber';

export const useEditUserDialog = () => {
    const classes = useStyles();
    const { userGroups, setUserGroups, reloadUserGroups } = useGlobal();
    const auth = useAuth();
    const [open, setOpen] = useState(false);
    const [userId, setUserId] = useState('');
    const [inputAccount, setInputAccount] = useState('');
    const [inputPassword, setInputPassword] = useState('');
    const [inputConfirmPassword, setInputConfirmPassword] = useState('');
    const [inputUserName, setInputUserName] = useState('');
    const [inputTel, setInputTel] = useState('');
    const [inputMobile, setInputMobile] = useState('');
    const [inputEmail, setInputEmail] = useState('');
    const [inputAddress, setInputAddress] = useState('');
    const [originUserGroups, setOriginUserGroups] = useState<UserGroup[]>([]);
    const [inputUserGroups, setInputUserGroups] = useState<UserGroup[]>([]);
    const [existCarIds, setExistCarIds] = useState<string[]>([]);
    const [inputCarIds, setInputCarIds] = useState<string[]>([]);
    const [inputMaxCarNumber, setInputMaxCarNumber] = useState<number>(9);
    const [tempCarId, setTempCarId] = useState('');
    const [onUpdateUser, setOnUpdateUser] = useState<
        (
            userId: string,
            inputAccount: string,
            inputPassword: string,
            inputUserName: string,
            inputTel: string,
            inputMobile: string,
            inputEmail: string,
            inputAddress: string,
            inputUserGroups: UserGroup[],
            inputCarIds: string[],
        ) => void
    >(() => () => {});
    const onOpen = () => setOpen(true);
    const onClose = () => setOpen(false);
    const onReset = () => {
        setUserId('');
        setInputAccount('');
        setInputPassword('');
        setInputConfirmPassword('');
        setInputUserName('');
        setInputTel('');
        setInputMobile('');
        setInputEmail('');
        setInputAddress('');
        setOriginUserGroups([]);
        setInputUserGroups([]);
        setExistCarIds([]);
        setInputCarIds([]);
        setInputMaxCarNumber(9);
        setTempCarId('');
        setOnUpdateUser(() => () => {});
    };
    useEffect(() => {
        if (open) {
            reloadUserGroups();
            api.car
                .get({})
                .then((ret) => ret.data && setExistCarIds(ret.data.filter((d) => d.carId && d.carId.length > 0).map((d) => d.carId!)));
        } else {
            onReset();
        }
    }, [open]);
    useEffect(() => {
        setInputUserGroups(
            userGroups.filter((userGroup) =>
                originUserGroups.map((originUserGroup) => originUserGroup.userGroupId).includes(userGroup.userGroupId!),
            ),
        );
    }, [userGroups]);
    useEffect(() => {
        setInputUserGroups(
            userGroups.filter((userGroup) =>
                originUserGroups.map((originUserGroup) => originUserGroup.userGroupId).includes(userGroup.userGroupId!),
            ),
        );
    }, [originUserGroups, userGroups]);
    useEffect(() => {
        api.user.get({ userId: userId, relations: { userGroups: true, cars: true } }).then((ret) => {
            if (ret.data && ret.data.length > 0) {
                const user = ret.data[0];
                // setUserId('');
                setInputAccount(user.account || '');
                // setInputPassword('');
                // setInputConfirmPassword('');
                setInputUserName(user.userName || '');
                setInputTel(user.tel || '');
                setInputMobile(user.mobile || '');
                setInputEmail(user.email || '');
                setInputAddress(user.address || '');
                setOriginUserGroups(user.userGroups || []);
                setInputUserGroups(user.userGroups || []);
                setInputCarIds((user.cars || []).map((car) => car.carId || ''));
                setInputMaxCarNumber(9);
                // setTempCarId('');
            }
        });
        api.car.get({}).then((ret) => setExistCarIds((ret.data || []).map((car) => car.carId || '')));
    }, [userId]);
    return {
        classes,
        auth,
        alert,
        open,
        setOpen,
        userId,
        setUserId,
        inputAccount,
        setInputAccount,
        inputPassword,
        setInputPassword,
        inputConfirmPassword,
        setInputConfirmPassword,
        inputUserName,
        setInputUserName,
        inputTel,
        setInputTel,
        inputMobile,
        setInputMobile,
        inputEmail,
        setInputEmail,
        inputAddress,
        setInputAddress,
        originUserGroups,
        setOriginUserGroups,
        inputUserGroups,
        setInputUserGroups,
        existCarIds,
        setExistCarIds,
        inputCarIds,
        setInputCarIds,
        inputMaxCarNumber,
        setInputMaxCarNumber,
        tempCarId,
        setTempCarId,
        onUpdateUser,
        setOnUpdateUser,
        userGroups,
        setUserGroups,
        onOpen,
        onClose,
        onReset,
    };
};

export interface EditUserDialogProps extends ReturnType<typeof useEditUserDialog> {}

export const EditUserDialog = (props: EditUserDialogProps): React.ReactElement => {
    return (
        <Dialog fullWidth={true} maxWidth={'lg'} open={props.open} onClose={props.onClose}>
            <AppBar position='sticky' className={props.classes.appBar} color='primary'>
                <Toolbar>
                    <Typography style={{ width: '100%', textAlign: 'center' }} variant='h4' component={'div'}>
                        {props.userId.length > 0 ? '更新使用者' : '新增使用者'}
                    </Typography>
                    <Typography style={{ position: 'absolute', right: '0px' }} variant='h4' component={'div'}>
                        <Button color='inherit' onClick={props.onClose}>
                            <Typography variant='h5'>
                                <FontAwesomeIcon icon={faXmark} size='lg' fixedWidth />
                            </Typography>
                        </Button>
                    </Typography>
                </Toolbar>
            </AppBar>
            <Grid container flexDirection={'column'} padding={4}>
                <Grid container item flexDirection={'row'}>
                    <Grid container item flexDirection={'row'} xs={12}>
                        <Grid container item flexDirection={'row'} xs={12} md={6}>
                            <TextField
                                value={props.inputAccount}
                                onChange={(e) => props.setInputAccount(e.target.value)}
                                variant='outlined'
                                label={
                                    <>
                                        <span style={{ color: 'red' }}>*</span>
                                        {'帳號'}
                                    </>
                                }
                                style={{ width: '100%', margin: 4, marginTop: 12 }}
                            />
                        </Grid>
                        <Grid container item flexDirection={'row'} xs={12} md={6}>
                            <TextField
                                value={props.inputUserName}
                                onChange={(e) => props.setInputUserName(e.target.value)}
                                variant='outlined'
                                label={
                                    <>
                                        <span style={{ color: 'red' }}>*</span>
                                        {'使用者名稱'}
                                    </>
                                }
                                style={{ width: '100%', margin: 4, marginTop: 12 }}
                            />
                        </Grid>
                        <Grid container item flexDirection={'row'} xs={12} md={6}>
                            <TextField
                                type={'password'}
                                autoComplete={'new-password'}
                                value={props.inputPassword}
                                onChange={(e) => props.setInputPassword(e.target.value)}
                                variant='outlined'
                                label={
                                    <>
                                        {`使用者密碼${
                                            props.inputPassword.length > 0 && props.inputPassword.length < 6 ? '(密碼長度至少6碼)' : ''
                                        }`}
                                    </>
                                }
                                error={props.inputPassword.length > 0 && props.inputPassword.length < 6}
                                style={{ width: '100%', margin: 4, marginTop: 12 }}
                            />
                        </Grid>
                        <Grid container item flexDirection={'row'} xs={12} md={6}>
                            <TextField
                                type={'password'}
                                autoComplete={'new-password'}
                                value={props.inputConfirmPassword}
                                onChange={(e) => props.setInputConfirmPassword(e.target.value)}
                                variant='outlined'
                                label={
                                    <>
                                        {`再次輸入密碼${
                                            props.inputConfirmPassword.length > 0 && props.inputPassword != props.inputConfirmPassword
                                                ? '(密碼不一致)'
                                                : ''
                                        }`}
                                    </>
                                }
                                error={props.inputConfirmPassword.length > 0 && props.inputPassword != props.inputConfirmPassword}
                                style={{ width: '100%', margin: 4, marginTop: 12 }}
                            />
                        </Grid>
                        <Grid container item flexDirection={'row'} xs={12} md={6}>
                            <TextField
                                value={props.inputTel}
                                onChange={(e) => props.setInputTel(e.target.value)}
                                variant='outlined'
                                label={<>{'市話'}</>}
                                style={{ width: '100%', margin: 4, marginTop: 12 }}
                            />
                        </Grid>
                        <Grid container item flexDirection={'row'} xs={12} md={6}>
                            <TextField
                                value={props.inputMobile}
                                onChange={(e) => props.setInputMobile(e.target.value)}
                                variant='outlined'
                                label={<>{'手機'}</>}
                                style={{ width: '100%', margin: 4, marginTop: 12 }}
                            />
                        </Grid>
                        <Grid container item flexDirection={'row'} xs={12} md={6}>
                            <TextField
                                value={props.inputEmail}
                                onChange={(e) => props.setInputEmail(e.target.value)}
                                variant='outlined'
                                label={<>{'電子信箱'}</>}
                                style={{ width: '100%', margin: 4, marginTop: 12 }}
                            />
                        </Grid>
                        <Grid container item flexDirection={'row'} xs={12} md={6}>
                            <TextField
                                value={props.inputAddress}
                                onChange={(e) => props.setInputAddress(e.target.value)}
                                variant='outlined'
                                label={<>{'地址'}</>}
                                style={{ width: '100%', margin: 4, marginTop: 12 }}
                            />
                        </Grid>
                        <Grid container item flexDirection={'row'} xs={12}>
                            <Autocomplete
                                multiple
                                value={props.inputUserGroups}
                                onChange={(event, newValue) => props.setInputUserGroups(newValue)}
                                options={props.userGroups}
                                getOptionLabel={(option) => option.descr!}
                                filterSelectedOptions
                                renderInput={(params) => <TextField {...params} label='使用者群組' placeholder='搜尋使用者群組' />}
                                getOptionDisabled={(option) => (option.authority || 0) >= props.auth.profile.authority}
                                renderTags={(tagValue, getTagProps) =>
                                    tagValue.map((option, index) => (
                                        <Chip
                                            label={option.descr!}
                                            {...getTagProps({ index })}
                                            disabled={(option.authority || 0) >= props.auth.profile.authority}
                                        />
                                    ))
                                }
                                disableClearable={true}
                                style={{ width: '100%', margin: 4, marginTop: 12 }}
                            />
                        </Grid>
                        <Grid container item flexDirection={'row'} xs={12}>
                            <Autocomplete
                                multiple
                                freeSolo
                                value={props.inputCarIds}
                                onChange={(event, newValue) => {
                                    const newCarIds = newValue
                                        .map((v) => v.toUpperCase())
                                        .filter((v) => v != undefined)
                                        .filter((v) => regLicensePlateNumber.test(v!))
                                        .filter((v, i) => i < props.inputMaxCarNumber);
                                    props.setInputCarIds(newCarIds);
                                }}
                                onInputChange={(event, newInputValue) => props.setTempCarId(newInputValue.toUpperCase())}
                                options={props.existCarIds}
                                getOptionLabel={(option) => option || ''}
                                filterSelectedOptions
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        label={
                                            <>
                                                <span style={{ color: 'red' }}>*</span>
                                                {props.tempCarId.length > 0 && props.inputCarIds.length == props.inputMaxCarNumber
                                                    ? '已超出最大數量'
                                                    : props.tempCarId.length > 0 && !regLicensePlateNumber.test(props.tempCarId)
                                                    ? `請輸入正確格式的車牌號碼，最多${props.inputMaxCarNumber}台`
                                                    : `請輸入車牌號碼，最多${props.inputMaxCarNumber}台`}
                                            </>
                                        }
                                        error={props.tempCarId.length > 0 && !regLicensePlateNumber.test(props.tempCarId)}
                                        placeholder={
                                            props.inputCarIds.length >= props.inputMaxCarNumber ? '已到達最大數量' : '請輸入車牌號碼'
                                        }
                                    />
                                )}
                                renderTags={(tagValue, getTagProps) =>
                                    tagValue.map((option, index) => <Chip label={option || ''} {...getTagProps({ index })} />)
                                }
                                disableClearable={true}
                                style={{ width: '100%', margin: 4, marginTop: 12 }}
                            />
                        </Grid>
                        <Grid container item flexDirection={'row'} justifyContent={'flex-end'} xs={12}>
                            <Button
                                disabled={
                                    ![
                                        props.inputAccount.length > 0,
                                        props.inputUserName.length > 0,
                                        props.inputPassword.length >= 6 || props.inputPassword.length == 0,
                                        props.inputPassword == props.inputConfirmPassword,
                                    ].every((v) => v)
                                }
                                className={props.classes.buttonCyan}
                                style={{ margin: 4, marginTop: 12 }}
                                onClick={() => {
                                    props.onUpdateUser &&
                                        props.onUpdateUser(
                                            props.userId,
                                            props.inputAccount,
                                            props.inputPassword,
                                            props.inputUserName,
                                            props.inputTel,
                                            props.inputMobile,
                                            props.inputEmail,
                                            props.inputAddress,
                                            props.inputUserGroups,
                                            props.inputCarIds,
                                        );
                                }}
                            >
                                <FontAwesomeIcon icon={faFilePen} fixedWidth />
                                {'確定更新'}
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </Dialog>
    );
};
